import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {Track, TrackTopPlaylists} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {AnalyticFilters} from '@deezer/next/services/api/Legacy/requests/types';

const {get} = requestWrapper;

const requests = {
	get: (isrc: string, deezerId?: number) =>
		get<DataResponseWrapper<Track>>(endpoints.trackByISRC(isrc), {
			params: {
				deezerId: deezerId || undefined,
			},
		}),
	getTopPlaylists: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<TrackTopPlaylists>>(endpoints.topPlaylists(isrc), {
			params: filters,
		}),
};

export default requests;
